import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import GroupButtonSubmit from 'components/CustomButton/GroupButtonSubmit';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { getColor, getColorText } from 'store/settings';
const ButtonSubmit = ({
  title,
  onCancel,
  onClick,
  disabled,
  disabledCancel,
}) => {
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    .btn-danger {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn-danger:hover {
      border-color: ${colorStatus} !important;
      background-color: #ffffff !important;
      color: ${colorStatus} !important;
    }
  `;
  return (
    <GroupButtonSubmit onCancel={onCancel} disabled={disabledCancel}>
      <Stylescal>
        <Button.Ripple
          color="danger"
          className="round"
          onClick={onClick}
          disabled={disabled}
        >
          {title}
        </Button.Ripple>
      </Stylescal>
    </GroupButtonSubmit>
  );
};
ButtonSubmit.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledCancel: PropTypes.bool,
};

export default ButtonSubmit;
